if ($('#coms-market-ratings-tv-audience-comp').length) {

    var form_coms_markets;
    var dt;
    var chart_stations=[];
    $('#custom_chart').on('click', function () {
        var html_type= ' <option value=""></option>' +
            '                                            <option value="pie">Pie</option>' +
            '                                            <option value="column">Column (Vertical)</option>' +
            '                                            <option value="bar">Column (Horizontal)</option>';

        $('#chart_type').select2({
            minimumResultsForSearch: 5,
            placeholder: 'Select one....',
        });
        $('#chart_type').html(html_type);
        $('#chart_data_type').select2({
            minimumResultsForSearch: 5
        });
        $('#chart_demo_options').select2({
            placeholder: "Select at least one..",
            closeOnSelect: false,
            placeholder: 'Select at least one....',
        });

        var table=   $('#ratings_market_comp_table ').DataTable();
        console.log('table',table);
        var ages=[];
        table.rows().eq(0).each( function ( index ) {
            var row = table.row( index );

            var data = row.data();
            console.log('row.data', data)
            for(var i in data) {
                console.log('i', i);
                if(i !== 'base' && i!=='gender' && i !== 'station' && ages.indexOf(i) === -1)
                    ages.push(i);
            }
        } );
        $('#chart_age').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });
        var html = '';
        for(var i in ages)
            html +='<option value="'+ages[i]+'">'+ages[i]+'</option>';
        $('#chart_age').html(html).multiSelect('refresh');
        $('#chart_stations').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_sta'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_sta'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });

        var html = '';
        for(var i in chart_stations) {
            var string= chart_stations[i].split('(');
            html += '<option value="' + string[0].trim() + '">' + chart_stations[i] + '</option>';
        }
        $('#chart_stations').html(html).multiSelect('refresh');

        $('#sel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('select_all');
        });
        $('#desel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('deselect_all');
        });
        $('#sel_all_chart_sta').on('click', function (e) {
            $('#chart_stations').multiSelect('select_all');
        });
        $('#desel_all_chart_sta').on('click', function (e) {
            $('#chart_stations').multiSelect('deselect_all');
        });

        $('#graphsOptionsModal').modal('show');
    });
    $('#submit_charts_options').on('click', function(){
        if($('#chart_type option:selected').val() == ''){
            swal({
                    title: "Warning",
                    text: "Select Chart Type first...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_demo_options').val().length == 0){
            swal({
                    title: "Warning",
                    text: "Select at least one Demo...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_age').val().length == 0){
            swal({
                    title: "Warning",
                    text: 'Select at least one Age Range..',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_stations').val().length == 0){
            swal({
                    title: "Warning",
                    text: 'Select at least one Station..',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else {
            show_overlay_loader('#graphsOptionsModal .modal-content');
            var age_charts = $('#chart_age').val();
            var st_charts =  $('#chart_stations').val();
            var data_type = 'Impressions';
            var demo_type = $('#chart_demo_options').val();

            console.log('vendor_charts', age_charts);
            console.log('demo_type', demo_type);
            var results=[];
            var results_base=[];
            for(var y in st_charts) {
                results[st_charts[y]] = [];
                results_base[st_charts[y]] = [];

            }

            var thousands_total = 0;
            console.log('results', results);

            var table= $('#ratings_market_comp_table ').DataTable();
            var st='';
            table.rows().eq(0).each( function ( index ) {
                var row = table.row( index );
                var data = row.data();
                if(data.gender == 'P')
                    st= data.station;
                if(data['gender'] == demo_type && st_charts.indexOf(st) !== -1){
                    for(var i in age_charts){
                        results[st][age_charts[i]] = (data[age_charts[i]].impressions == '')? 0 : parseFloat(data[age_charts[i]].impressions);
                        results_base[st][age_charts[i]] = (data.base == '')? 0 : parseFloat(data.base);
                        thousands_total += (data[age_charts[i]].impressions == '')? 0 : parseFloat(data[age_charts[i]].impressions);
                    }
                }
            });
            var format= '';
            console.log('results', results);

            if ($('#chart_type option:selected').val() == 'column' || $('#chart_type option:selected').val() == 'bar') {
                var series=[];
                for(var demo in results){
                    var data=[];
                    for(var age in results[demo]){
                        var perc= parseFloat( Number(Math.round(((Math.round(parseFloat(results[demo][age])/1000) / Math.ceil(parseFloat(results_base[demo][age])/1000)) * 100) +'e1')+'e-1'));
                        if($('#chart_data_type option:selected').val() == 'both') {
                            data.push({
                                name: $('#chart_demo_options option:selected').val()+' '+ age,
                                y: parseFloat(parseFloat(results[demo][age]) / 1000),
                                percentage: parseFloat(perc),
                                drilldown: null,
                            });
                        }
                        else if($('#chart_data_type option:selected').val() == 'impressions'){
                            data.push({
                                name: $('#chart_demo_options option:selected').val()+' '+ age,
                                y: parseFloat(parseFloat(results[demo][age]) / 1000),
                                // percentage: parseFloat(perc),
                                drilldown: null,
                            });
                        }
                        else{
                            data.push({
                                name: $('#chart_demo_options option:selected').val()+' '+ age,
                                y: parseFloat(perc),
                                drilldown: null,
                            });
                        }

                    }
                    series.push({
                        name: demo,
                        data: data,
                    });
                }
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.percentage:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.y:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';
                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#book').html(),
                    },
                    subtitle:{
                        text:  $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ' )',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0,
                            //  stacking: 'percent'
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px"><b>{point.key}</b></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:5px"><b>'+ format +'</td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true,
                    },
                    series: series,
                });
            }
            else{
                var series = [];
                var data2 = [];

                for(var demo in results){
                    var total = 0;
                    var arr= [];
                    var cont=0;
                    var total_age= 0;
                    for(var age in results[demo]){
                        total += parseFloat(results[demo][age]);
                        total_age = parseFloat(results[demo][age]);
                        var perc= parseFloat( Number(Math.round(((Math.round(parseFloat(results[demo][age])/1000) / Math.ceil(parseFloat(results_base[demo][age])/1000)) * 100) +'e1')+'e-1'));
                        arr.push({name: age, y: parseFloat(total_age)/1000, x: perc, drilldown: null});
                        cont++;
                    }
                    data2.push({
                        name: demo,
                        id: demo,
                        data: arr,
                    });
                    var percent = 0;
                    percent= (thousands_total > 0) ? parseFloat(((parseFloat(total ) * 100) / thousands_total)).toFixed(2) : 0;

                    series.push({
                        name: demo,
                        y: total / 1000,
                        x: percent,
                        drilldown: demo,
                    });
                }
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.x:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.x:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';

                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type_name = "Thousands";
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type_name = "Percent"
                else
                    dt_type_name = 'Thousands & Percent';
                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#book').html(),
                    },
                    subtitle:{
                        text:    $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ')<br> <span style="color: red"> Click the slices to view  '+ dt_type +' by Age Range. </span>',
                          },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true,
                                // format: '${point.y:.2f}'
                            },
                            showInLegend: true,
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">'+ dt_type_name +': </td>' +
                            '<td style="padding:5px"><b>'+ format +' </b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    series: [
                        {
                            name: 'Station',
                            colorByPoint: true,
                            data: series
                        }
                    ],
                    drilldown: {
                        series: data2
                    }
                });
            }

            $('#GraphsModal').modal('show');
            hide_overlay_loader('#graphsOptionsModal .modal-content');
        }
    });

    $(document).ready(function(){
        show_loader();
        dayPartInputInit('16:00', '23:00', 'tv');
        $.ajax({
            type: "GET",
            url: '/comscore/tv/local/markets',
            dataType: 'json',
            success: function (data) {
                var html = '<option value="">Select one...</option>';
                $.each(data['result_rows'], function (index, value) {
                    html += '<option value="'+ value[0] +'" data-start="' + value[2] + '" data-end="' + value[3] + '">'+ value[1] +'</option>';
                });
                $("#coms_form_market_market").html(html);

                form_coms_markets = data;
                console.log("init");
                $("#coms_form_market_market").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    onMarketChange($(this).val());
                });

                $('#form_comp_station_market').multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    }
                });

                $('#form_reset').bind('click', function(){
                    compAudienceReset();
                });

                $('#form_submit_coms_market').bind('click', function(){
                    chart_stations = []
                    $('#form_comp_station_market option:selected').each(function () {
                        chart_stations[$(this).val()] = $(this).html();
                    });
                    compMarketAudienceSubmit();
                });

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    });

    $("#form_from_market, #form_to_market").on("focusout", function () {
        if(moment($(this).val()) > moment($("#coms_form_market_market option:selected").data("end")) || moment($(this).val()) < moment($("#coms_form_market_market option:selected").data("start"))) {
            global_notification("warning", "The dates has to be between " + moment($("#coms_form_market_market option:selected").data("start")).format("MM/DD/YYYY") + " and " + moment($("#coms_form_market_market option:selected").data("end")).format("MM/DD/YYYY") + ".")
            $(this).val(($(this).attr("id") === "form_from_market") ? $("#coms_form_market_market option:selected").data("start") : $("#coms_form_market_market option:selected").data("end"))
        }
    })

    var onMarketChange = function(market){
        show_loader();
        $("#form_from_market").attr("min", $("#coms_form_market_market option:selected").data("start"))
        $("#form_from_market").attr("max", $("#coms_form_market_market option:selected").data("end"))
        $("#form_from_market").val($("#coms_form_market_market option:selected").data("start"))
        $("#form_to_market").attr("min", $("#coms_form_market_market option:selected").data("start"))
        $("#form_to_market").attr("max", $("#coms_form_market_market option:selected").data("end"))
        $("#form_to_market").val($("#coms_form_market_market option:selected").data("end"))
        $.ajax({
            type: "GET",
            url: '/ratings/comscore/stations/' + market,
            dataType: 'json',
            success: function (data) {
                console.log(data);
                var html = '';
                $.each(data['result_rows'], function (index, value) {
                    if(value[5] == market)
                        html += '<option value="'+ value[0] +'">'+ value[1] +' ('+ value[10] +')</option>';
                });

                $("#form_comp_station_market").html(html);
                /*$("#form_comp_station_market").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {

                });*/

                $('#form_comp_station_market').multiSelect('refresh');

                hide_loader();
            },
            error: function (err) {
                hide_loader();
            }
        });
    };

    var compAudienceReset = function(sel){
        var input = $('#coms_form_market_market');

        input.data('select2').destroy();
        input.unbind('select2:select');

        var html = '';
        $.each(form_coms_markets['result_rows'], function (index, value) {
            html += '<option value="'+ value[0] +'">'+ value[1] +'</option>';
        });
        input.html(html);
        input.select2({
            placeholder: "Select one...",
            minimumResultsForSearch: 10
        }).on('select2:select', function (evt) {
            onMarketChange(this);
        });

        input = $('#form_comp_station_market');
        input.multiSelect('refresh');

        $("#form_from").val("");
        $("#form_to").val("");

    };

    var compMarketAudienceSubmit = function(){
        show_loader();
        var dp_start = moment($('#form_day_part_start').val(), 'h:mm A');
        var dp_end = moment($('#form_day_part_end').val(), 'h:mm A');
        var station = [];
        $("#form_comp_station_market option:selected").each(function(){
            station.push($(this).val());
        });
        console.log(station);
        var from = $("#form_from_market").val();
        var to = $("#form_to_market").val();
        var market = $("#coms_form_market_market option:selected").val();
        var days = $('#form_day_part_days').val();
        var day_part_str = $('#form_day_part_days').val() + dp_start.format('HHmm') + dp_end.format('HHmm');

        $.ajax({
            type: 'POST',
            url: '/ratings/comscore/composition/market/audience',
            data: {
                start_time: dp_start.format('HH:mm:00'),
                end_time: dp_end.format('HH:mm:00'),
                days: days,
                from: from,
                to: to,
                market: market,
                distributor: station
            },
            dataType: 'json',
            encode: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                console.log(data);

                $('#book').html($("#coms_form_market_market option:selected").text());
                $('#day_part').html(ratingsHumanDaypart(day_part_str));

                var table_data = [];
                $.each(data['data'], function(index, value){

                    var p_base = 0;
                    var m_base = 0;
                    var w_base = 0;
                    var startp = 3;
                    var startm = 15;
                    var startw = 27;
                    while(startp < 15) {
                        p_base += (typeof value['result_rows'][0] !== "undefined" && typeof value['result_rows'][0][startp] !== "undefined" && !isNaN(value['result_rows'][0][startp]) && value['result_rows'][0][startp] !== null) ? Number(Math.round((value['result_rows'][0][startp]) +'e1')+'e-1') : 0;
                        startp+=2;
                    }
                    while(startm < 27) {
                        m_base += (typeof value['result_rows'][0] !== "undefined" && typeof value['result_rows'][0][startm] !== "undefined" && !isNaN(value['result_rows'][0][startm]) && value['result_rows'][0][startm] !== null) ? Number(Math.round((value['result_rows'][0][startm]) +'e1')+'e-1') : 0;
                        startm+=2;
                    }
                    while(startw < 39) {
                        w_base += (typeof value['result_rows'][0] !== "undefined" && typeof value['result_rows'][0][startw] !== "undefined" && !isNaN(value['result_rows'][0][startw]) && value['result_rows'][0][startw] !== null) ? Number(Math.round((value['result_rows'][0][startw]) +'e1')+'e-1') : 0;
                        startw+=2;
                    }
                    startp = 3;
                    startm = 15;
                    startw = 27;

                    var push = {
                        'station': (typeof value['result_rows'][0] !== "undefined" && typeof value['result_rows'][0][1] !== "undefined") ? value['result_rows'][0][1] : '',
                        'gender': 'P',
                        'base': p_base
                    };
                    $.each(data['demos']["A"], function(index, demo){
                        push[index] = {
                            impressions: (typeof value['result_rows'][0] !== "undefined" && typeof value['result_rows'][0][startp] !== "undefined" && !isNaN(value['result_rows'][0][startp]) && value['result_rows'][0][startp] !== null) ? Number(Math.round((value['result_rows'][0][startp]) +'e1')+'e-1') : 0,
                            intab: true,
                        };
                        startp+=2;
                    });
                    table_data.push(push);

                    push = {
                        'station': '',
                        'gender': 'M',
                        'base': m_base
                    };
                    $.each(data['demos']["A"], function(index, demo){
                        push[index] = {
                            impressions: (typeof value['result_rows'][0] !== "undefined" && typeof value['result_rows'][0][startm] !== "undefined" && !isNaN(value['result_rows'][0][startm]) && value['result_rows'][0][startm] !== null) ? Number(Math.round((value['result_rows'][0][startm]) +'e1')+'e-1') : 0,
                            intab: true,
                        };
                        startm+=2;
                    });
                    table_data.push(push);

                    push = {
                        'station': '',
                        'gender': 'F',
                        'base': w_base
                    };
                    $.each(data['demos']["A"], function(index, demo){
                        push[index] = {
                            impressions: (typeof value['result_rows'][0] !== "undefined" && typeof value['result_rows'][0][startw] !== "undefined" && !isNaN(value['result_rows'][0][startw]) && value['result_rows'][0][startw] !== null) ? Number(Math.round((value['result_rows'][0][startw]) +'e1')+'e-1') : 0,
                            intab: true,
                        };
                        startw+=2;
                    });
                    table_data.push(push);
                });

                console.log(table_data);

                var dt_options = {
                    columns: [
                        {
                            data: "station"
                        },{
                            data: "gender"
                        },{
                            data: "base"
                        },{
                            data: "18 - 24"
                        },{
                            data: "25 - 34"
                        },{
                            data: "35 - 44"
                        },{
                            data: "45 - 54"
                        },{
                            data: "55 - 64"
                        },{
                            data: "65+"
                        }
                    ],
                    "columnDefs": [
                        { "orderable": false, "targets": '_all' },
                        {
                            "render": function ( data, type, row, meta ) {
                                var curr_intab = false;
                                if(meta['col'] > 1){
                                    if(meta['col'] === 2){
                                        data = Math.ceil(data / 1000).toLocaleString("en-US", {
                                            minimumFractionDigits: 0
                                        });
                                    }else{
                                        if(data['impressions'] !== ''){
                                            /*if(data['impressions'] - Math.round(data['impressions']/1000)*1000 > 400){
                                                data['impressions'] += 200;
                                            }*/
                                            var html = '<div class="left">' + (typeof data['impressions'] !== "undefined" && data['impressions'] !== "" && data['impressions'] !== null && data['impressions'] > 0) ? Number(Math.round((data['impressions'] / 1000) +'e0')+'e-0').toLocaleString("en-US", {
                                                minimumFractionDigits: 0
                                            }) : 0;
                                            if(! data['intab']){
                                                curr_intab = true;
                                                html += '<span class="intab-indicator">&nbsp;✝</span>'
                                            }
                                            if(Math.ceil(row['base']) >= 35000){
                                                console.log(Math.round(data['impressions']/1000));
                                                console.log(Math.ceil(row['base']/1000));
                                            }
                                            html += '</div><div class="right"><span style="font-weight: 400;">(' + (isNaN(Number(Math.round(((Math.round(data['impressions']/1000) / Math.ceil(row['base']/1000)) * 100) +'e1')+'e-1').toString()) ? 0 :  Number(Math.round(((Math.round(data['impressions']/1000) / Math.ceil(row['base']/1000)) * 100) +'e1')+'e-1').toString()) + '%)</span></div>';

                                            data = html;
                                        }else{
                                            data = '';
                                        }
                                    }

                                }

                                return data;

                            },
                            "targets": '_all'
                        },
                        { "width": "7.5%", "targets": 'demo' }
                    ],
                    "order": [],
                    dom: 'Bfrtip',
                    buttons: [
                        'copy',
                        {
                            extend: 'excel',
                            messageTop: $('#book').html() +' > ' + $('#day_part').html(),
                            messageBottom: 'LEGAL DISCLAIMER: All metrics contained in this document are calculations of GaleForce Digital Technologies and have not been verified by Comscore.'
                        },
                        {
                            extend: 'csv',
                            messageTop:  $('#book').html() +' >  ' + $('#day_part').html(),
                            messageBottom: 'LEGAL DISCLAIMER: All metrics contained in this document are calculations of GaleForce Digital Technologies and have not been verified by Comscore.'
                        },
                        {
                            extend: 'print',
                            messageTop:  $('#book').html() +' > ' + $('#day_part').html(),
                            messageBottom: '<br/><br/><table cellspacing="0" style="width: 100%;"><tbody><tr><td colspan="7" style="background-color: #F8AB91; font-weight: bold;padding:2px 2px 2px 6px;width: 100%;">LEGAL DISCLAIMER</td></tr><tr><td colspan="7" style="padding:2px 2px 2px 6px;width: 100%;background-color: #fce4d6">All metrics contained in this document are calculations of GaleForce Digital Technologies and have not been verified by Comscore.</td></tr></tbody></table>'
                        },
                    ],
                    "searching": false,
                    "paging": false,
                    "info": false,
                    data: table_data
                };

                if(typeof dt !== 'undefined'){
                    dt.destroy();
                    $('#ratings_market_comp_table').find('tbody').empty();
                }

                dt = $('#ratings_market_comp_table').DataTable( dt_options );

                if($('.ratings-table-container').hasClass('hidden')){
                    $('.ratings-table-container').removeClass('hidden');
                }

                $('#tv_comp_market_generate_panel').find('div.clickable').click();

                hide_loader();
            },
            error: function (err) {
                ajax_error();
                debug(err.responseText);
                hide_loader();
            }
        });

    };


    var exportToExcel = function(html){
        html += '<br/><br/><table cellspacing="0" style="width: 100%;"><tbody><tr><td colspan="7" style="font-weight: bold;padding:2px 2px 2px 6px;width: 100%;">LEGAL DISCLAIMER</td></tr><tr><td colspan="7" style="padding:2px 2px 2px 6px;width: 100%;">All metrics contained in this document are calculations of GaleForce Digital Technologies and have not been verified by Comscore.</td></tr></tbody></table>'
        var url='data:application/vnd.ms-excel,' + encodeURIComponent(html);
        location.href=url;
        return false;
    };

}
